/**
 * 等待某个积木块的出现。由于界面到延迟，某个刚创建的积木块可能不会立即出现，需要等待一段时间
 * @param id
 * @param timeout
 * @returns {Promise<unknown>}
 */
export default function expectBlock({id, timeout}) {
    return new Promise((resolve, reject)=>{
        if (!timeout) timeout = 3000;
        const interval = 100;
        let count = 0;
        let handle;
        const check = ()=>{
            count++;
            if (document.querySelector('[data-id="' + id + '"]')) {
                resolve();
                clearInterval(handle);
            }else {
                if (count * interval > timeout) {
                    reject(`期待的目标块：${id}未出现`);
                    clearInterval(handle);
                }
            }
        }
        handle = setInterval(check, interval);
    });
}
